import { BaSeContainer, BaSeFooter, BaSeHeader, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  shortName as appShortName,
  version as appVersion,
} from '../../../../package.json';
import {
  BreadcrumbsProvider,
  useBreadcrumbsData,
} from '../contexts/breadcrumbs-context';
import { useBackendVersionService } from '../services/backend-version-service';
import * as Styled from '../styled/app-styled';
import { BreadcrumbsContainer } from './breadcrumbs-container';
import { CycleProvider } from '../contexts/cycle-context';
import { useHeader } from '../helpers/header-helper';
import { EvaluationPanelConditionalProvider } from '../../evaluation-panel/context/evaluation-panel-conditional-provider';

const {
  institucionais: { azulSebrae36 },
} = BaSeTheme.colors;

//Cor não mapeada no figma
const BG_COLOR_HEADER = '#f4f4f4';

const AppContainerInner: React.FC = ({ children }) => {
  const { keycloak } = Sebrae.useAuth();
  const { version: bffVersion } = useBackendVersionService();

  const version = React.useMemo(
    () => `${appVersion}${bffVersion ? ` (API: ${bffVersion})` : ''}`,
    [bffVersion],
  );

  const breadcrumbs = useBreadcrumbsData();

  const { menuItems } = useHeader();

  return (
    <Styled.AppContainerWrapper>
      <Styled.AppHeaderWrapper>
        <BaSeHeader
          collapsedBreakpoint="onTablet"
          delimitedOnBreakpoint="desktop"
          logoInverseColor={false}
          backgroundColor={BG_COLOR_HEADER}
          textColor={azulSebrae36}
          systemName={appShortName}
          menuItens={menuItems}
          customComponents={[
            {
              component: () => (
                <Styled.LogoWrapper>
                  <img
                    src="https://storage.googleapis.com/sebrae-hdqa-assets/comum/hdqa-logo.png"
                    loading="lazy"
                    alt="Logo HDQA - Histórias de quem atende"
                  />
                </Styled.LogoWrapper>
              ),
              showOnExpanded: true,
              showOnCollapsed: true,
            },
          ]}
          accountProfileProps={{
            keycloak,
            clientName: appShortName,
          }}
        />
      </Styled.AppHeaderWrapper>

      {breadcrumbs && <BreadcrumbsContainer {...breadcrumbs} />}

      <Styled.AppBodyWrapper>
        <BaSeContainer delimitedOnBreakpoint="desktop">
          {children}
        </BaSeContainer>
      </Styled.AppBodyWrapper>

      <BaSeFooter
        delimitedOnBreakpoint="desktop"
        systemName={appShortName}
        systemVersion={version}
        backgroundColor="white"
        hideLinks={true}
      />
    </Styled.AppContainerWrapper>
  );
};

export const AppContainer: React.FC = ({ children }) => (
  <EvaluationPanelConditionalProvider>
    <CycleProvider>
      <BreadcrumbsProvider>
        <AppContainerInner>{children}</AppContainerInner>
      </BreadcrumbsProvider>
    </CycleProvider>
  </EvaluationPanelConditionalProvider>
);
